import { render, staticRenderFns } from "./DashboardNotices.vue?vue&type=template&id=725bad86"
import script from "./DashboardNotices.vue?vue&type=script&lang=js"
export * from "./DashboardNotices.vue?vue&type=script&lang=js"
import style0 from "./DashboardNotices.vue?vue&type=style&index=0&id=725bad86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports